export default __webpack_public_path__ + "PierreRammah.4e8dd7f.jpg";